// extracted by mini-css-extract-plugin
export default {"unstyledButton":"Clickable-module__unstyledButton__2W44e"};